import { useEffect, useState } from 'react';

/**
 * Client-side pagination state for DataView tables.
 * Resets to page 1 when `resetKey` changes (e.g. filter scope or data identity).
 */
export function useClientPagination(pageSize: number, resetKey: unknown = 0) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  return {
    page,
    pageSize,
    onPageChange: setPage,
  };
}
